import { ExpenseStatusDTO } from "../dtos/expenseStatusDTO";
import { ExpenseByStatus } from "~/application/types/entities/ExpenseByStatus.type";

export function mapExpenseStatusDTO(data: ExpenseStatusDTO): ExpenseByStatus {
  return {
    total: data.total,
    byStatus: data.by_status
  };
}
